module.exports = __webpack_public_path__ + "hk.7e30d412d695ecfe3994.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/hk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/hk.svg
// module chunks = styles